<template>
  <q-page>
    <q-btn flat color="primary" class="q-ma-md full-width q-px-md" @click="addNewProduct">Add New Product</q-btn>
    <q-table
      :data="products"
      :columns="columns"
      separator="none"
      dense
      :loading="$apollo.queries.products.loading"
      :pagination.sync="pagination"
      @request="onRequest"
      :filter="filter"
      :rows-per-page-options="[10, 20, 50]"
      binary-state-sort
      row-key="id" >
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body="props">      
        <q-tr :props="props">
          <q-td>
            <q-img dense :src="((props.row.images[0] || {}).url) || ''" style="width: 25px; height: 25px;" contain />
          </q-td>
          <q-td key="brand" :props="props">{{ props.row.attributes.brand }}</q-td>
          <q-td key="reference" :props="props">{{ props.row.reference }}</q-td>
          <q-td key="range" :props="props">{{ props.row.attributes.range }}</q-td>
          <q-td key="name" :props="props"> <router-link :to="`/admin/products/${props.row.id}`">{{ props.row.name }}</router-link></q-td>
          <q-td key="material" :props="props">{{ props.row.attributes.material }}</q-td>
          <q-td key="size" :props="props">{{ props.row.attributes.size }}</q-td>
          <q-td key="grip" :props="props">{{ props.row.attributes.grip }}</q-td>
          <q-td key="holds" :props="props">{{ props.row.attributes.holds }}</q-td>
<!--          <q-td key="price" :props="props">${{ Number((props.row.skus[0]||{}).price || 0).toFixed(2) }}</q-td>-->
<!--          <q-td key="skus" :props="props">{{ props.row.skus.length }}</q-td>-->
          <q-td key="createdAt" :props="props">{{ fromNow(props.row.createdAt) }}</q-td>
          <q-td key="updatedAt" :props="props">{{ fromNow(props.row.updatedAt) }}</q-td>
<!--          <q-td key="actions" :props="props">-->
<!--            <q-btn dense flat icon="edit" size="sm" :to="`/admin/products/${props.row.id}`"></q-btn>-->
<!--            <q-btn dense flat icon="delete" size="sm" @click="deleteProduct(props.row)"></q-btn>-->
<!--          </q-td>-->
        </q-tr>
      </template>
    </q-table>
    <!--    <q-btn class="q-ma-md" @click="downloadStockList">Download Stock List</q-btn>-->
    <!--    <q-btn class="q-ma-md" @click="uploadNewStock">Upload New Stock</q-btn>-->
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'
import generateStockListAndDownload from '../../util/generateStockListAndDownload'
import adminNotifyError from '../../util/adminNotifyError'
import { makeSearchFilter } from '../../store/filters/getters'

export default {
  name: 'PageAdminStockOrders',
  apollo: {
    products () {
      return {
        query: gql`
          query products ($filter: ProductFilterInput, $limit: Int, $offset: Int, $orderBy: ProductsOrderByFieldInput, $descending: SortOrderInput) {
            products(filter: $filter, store: AllProducts, limit: $limit, offset: $offset, orderBy: $orderBy, descending: $descending) {
              products {
                id,
                name,
                attributes,
                reference,
                createdAt,
                updatedAt,
                images {
                  url
                  name
                },
                urlSlug,
                description,
#                skus {
#                  id,
#                  showInContainer,
#                  price,
#                  options,
#                  stock
#                }
              }
              count
            }
          }
        `,
        variables () {
          return {
            filter: makeSearchFilter(this.filter),
            limit: this.pagination.rowsPerPage,
            offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
            orderBy: this.pagination.sortBy,
            descending: this.pagination.descending ? 'Descending' : 'Ascending'
          }
        },
        update (result) {
          this.pagination.rowsNumber = result.products.count
          return result.products?.products
        },
        fetchPolicy: 'network-only'
      }
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY')
    },
    downloadStockList () {
      generateStockListAndDownload(this.products)
    },
    uploadNewStock () {
      this.$router.push('/admin/add-stock')
    },
    async addNewProduct () {
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation addProduct($input: ProductInput!) {
                addProduct (input: $input) {
                    id
                }
            }
          `,
          variables: {
            input: {
              attributes: {
                manufacturer: '',
                type: '',
                brand: '',
                range: '',
                grip: '',
                material: '',
                size: '',
                holds: 0,
                // Note that these attributes are required
                // to be a string that can be parsed as json. If they were passed as empty
                // strings for example then they would fail validation in the addProduct
                // function in the backend
                bolts: '[]',
                screws: '[]'
              },
              description: '',
              images: [],
              reference: 'new-reference',
              name: 'New Product',
              urlSlug: 'update-this'
            }
          }
        })
        if (!response.data.addProduct) throw Error('Could not add product.')
        this.$router.push(`/admin/products/${response.data.addProduct.id}`)
      } catch (ex) {
        this.$q.notify({
          message: ex.message,
          color: 'negative',
          icon: 'report_problem'
        })
      }
    },
    deleteProduct (row) {
      const stockForProduct = row.skus.reduce((p, c) => p + c.stock, 0)
      if (stockForProduct) {
        this.$q.dialog({
          title: 'Delete Product',
          message: `You may not delete ${row.reference} as it has ${stockForProduct} items in stock.  Please remove all stock first.`
        })
        return
      }
      this.$q.dialog({
        title: 'Delete Product',
        message: `Are you sure you want to delete the product ${row.reference}? This cannot be undone.`,
        cancel: true
      }).onOk(async () => {
        try {
          await this.$apollo.mutate({
            mutation: gql`
            mutation deleteProduct($id: ID!) {
                deleteProduct (id: $id)
            }
          `,
            variables: {
              id: row.id
            }
          })
          await this.$apollo.queries.products.refetch()
        } catch (error) {
          adminNotifyError(this.$q, 'Error!', error)
        }
      })
    },
    onRequest (props) {
      let { page, rowsPerPage, sortBy, descending } = props.pagination
      this.pagination.page = page
      this.pagination.rowsPerPage = rowsPerPage
      this.pagination.sortBy = sortBy
      this.pagination.descending = descending
    }
  },
  data () {
    return {
      filter: '',
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 10,
        sortBy: 'range'
      },
      columns: [
        { name: 'img' },
        { name: 'brand', required: true, label: 'Brand', align: 'left', field: row => row.attributes.brand, sortable: true },
        { name: 'reference', required: true, label: 'Reference', align: 'left', field: row => row.reference, sortable: true },
        { name: 'range', required: true, label: 'Range', align: 'left', field: row => row.attributes.range, sortable: true },
        { name: 'name', required: true, label: 'Name', align: 'left', field: row => row.name, sortable: true },
        { name: 'material', required: true, label: 'Material', align: 'left', field: row => row.attributes.material, sortable: true },
        { name: 'size', required: true, label: 'Size', align: 'left', field: row => row.attributes.size, sortable: true },
        { name: 'grip', required: true, label: 'Grip', align: 'left', field: row => row.attributes.grip, sortable: true },
        { name: 'holds', required: true, label: 'Holds', align: 'left', field: row => Number(row.attributes?.holds), sortable: true },
        // { name: 'price', required: true, label: 'Price', align: 'left', field: row => Number(row.skus?.[0]?.price || 0), sortable: true },
        // { name: 'skus', required: true, label: 'Skus', align: 'left', field: row => row.skus.length, sortable: true },
        { name: 'createdAt', required: true, label: 'Created', align: 'left', field: row => row.createdAt, sortable: true },
        { name: 'updatedAt', required: true, label: 'Updated', align: 'left', field: row => row.updatedAt, sortable: true }
        // { name: 'actions', required: true, label: 'Actions', align: 'centre', sortable: false }
      ]
    }
  }
}
</script>
